<template>
  <!-- ASSESS LIVE -->
  <v-app-bar
    v-if="$route.name == 'Assess_live' || $route.name == 'Dialog'"
    app
    flat
    dense
    class="navbar_style"
    color="white"
    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important"
  >
    <v-img
      :src="navbar_logo"
      contain
      max-height="40"
      :max-width="$vuetify.breakpoint.xs ? 174 : 250"
      position="left center"
    ></v-img>
    <v-spacer></v-spacer>

    <v-toolbar-items>
      <v-dialog v-model="dialogNew" persistent max-width="80vw" width="400px">
        <template v-slot:activator="{ on }">
          <v-btn
            title="Neu starten"
            plain
            small
            v-on="on"
            class="assess_live_button_style"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-repeat</v-icon>
            <span
              v-if="
                $vuetify.breakpoint.mdAndUp && navar_language_fragments != null
              "
              >{{ navar_language_fragments.restart }}</span
            >
            <!-- <span v-else-if="$vuetify.breakpoint.smAndDown">Neu starten</span> -->
          </v-btn>
        </template>
        <v-card v-if="navar_language_fragments != null">
          <v-card-title class="text-h5">
            {{ navar_language_fragments.restart_pop_up.header }}</v-card-title
          >
          <v-card-text
            >{{ navar_language_fragments.restart_pop_up.text }}
          </v-card-text>
          <v-card-actions
            class="d-flex flex-wrap justify-center justify-sm-end"
          >
            <v-btn text color="backdrop" @click="dialogNew = false">
              {{ navar_language_fragments.restart_pop_up.btn_back }}
            </v-btn>
            <v-btn
              color="primary"
              outlined
              class="ml-0 ml-sm-2"
              @click="restart_or_delete('restart')"
              ><v-icon left>mdi-repeat</v-icon>
              {{ navar_language_fragments.restart_pop_up.btn_restart }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar-items>

    <v-toolbar-items>
      <v-dialog v-model="dialogDel" persistent max-width="80vw" width="400px">
        <template v-slot:activator="{ on }">
          <v-btn
            title="Abbrechen"
            color="error"
            plain
            small
            v-on="on"
            class="assess_live_button_style"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-exit-run</v-icon>
            <span
              v-if="
                $vuetify.breakpoint.mdAndUp && navar_language_fragments != null
              "
              >{{ navar_language_fragments.delete }}</span
            >
            <!-- <span v-else-if="$vuetify.breakpoint.smAndDown">Löschen</span> -->
          </v-btn>
        </template>
        <v-card v-if="navar_language_fragments != null">
          <v-card-title class="text-h5">
            {{ navar_language_fragments.delete_pop_up.header }}
          </v-card-title>
          <v-card-text
            >{{ navar_language_fragments.delete_pop_up.text }}
          </v-card-text>
          <v-card-actions
            class="d-flex flex-wrap justify-center justify-sm-end"
          >
            <v-btn color="primary" text @click="dialogDel = false">
              {{ navar_language_fragments.delete_pop_up.btn_back }}
            </v-btn>
            <v-btn
              color="error"
              class="ml-0 ml-sm-2"
              outlined
              @click="restart_or_delete('delete')"
            >
              <v-icon left>mdi-delete</v-icon>
              {{ navar_language_fragments.delete_pop_up.btn_delete }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar-items>

    <!-- open menu -->
    <v-toolbar-items>
      <v-menu
        offset-y
        content-class="app_nav_menu"
        @update:return-value="changeMenuStatus(1)"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon tile v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-subheader>Information</v-subheader>
          <!-- data security -->
          <v-list-item
            :to="'/privacy/' + $route.params.survey_id"
            target="_blank"
            title="Datenschutz"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="navar_language_fragments != null">{{
                navar_language_fragments.privacy
              }}</v-list-item-title>
              <v-list-item-title>Datenschutz</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>

  <!-- client navbar -->
  <v-app-bar
    v-else-if="
      $route.name != 'Assess_live' &&
      $route.name != 'Dialog' &&
      $route.name &&
      !$route.name.includes('Multichat')
    "
    app
    dense
    flat
    clipped-left
    class="navbar_style"
    :class="{ mobile: $vuetify.breakpoint.xs }"
    :key="$router.currentRoute.name"
    color="white"
    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important"
  >
    <!-- left title -->
    <div class="navigationPagination">
      <!-- for assess -->
      <!-- default -->
      <button v-if="$route.name == 'Assess'" @click="to_dashboard">
        <v-img
          :src="navbar_logo"
          contain
          max-height="40"
          :max-width="$vuetify.breakpoint.xs ? 174 : 250"
          position="left center"
        ></v-img>
      </button>

      <!-- show navigation -->
      <div
        v-else-if="
          $route.name == 'configurator' ||
          $route.name == 'Intrance' ||
          $route.name == 'Intrance_ai' ||
          $route.name == 'Share' ||
          $route.name == 'Analyse' ||
          $route.name == 'Account' ||
          $route.name == 'AnalyseMultiChat'
        "
        class="navigation_left d-flex"
      >
        <div
          v-if="$vuetify.breakpoint.smAndUp"
          @click="to_dashboard"
          class="nav-item d-flex align-center"
        >
          <v-icon left>mdi-chevron-left</v-icon>
          <span>Dashboard</span>
        </div>
        <span class="nav-item" v-else @click="to_dashboard"
          ><v-icon>mdi-chevron-left</v-icon></span
        >
        <div class="d-flex align-center question_name">
          <template v-if="$route.name != 'Account'">
            <span class="mx-2" v-if="$vuetify.breakpoint.smAndUp">/</span>

            <span
              :class="{ short: $vuetify.breakpoint.xs }"
              class="survey_name2"
              >{{ getSurveyName }}</span
            >
          </template>
        </div>
      </div>

      <!-- default show logo -->
      <button
        v-else-if="
          $route.name == 'Dashboard' ||
          $route.name == 'Root' ||
          $route.name == 'Impressum'
        "
        @click="to_dashboard"
      >
        <!-- on dashboard show logo -->
        <svg
          v-if="$route.name != null"
          data-name="Respeak"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 180"
          height="100%"
          width="100%"
          style="display: block; margin: auto; max-width: 150px"
        >
          <path
            class="cls-1"
            d="M378.48,164.55q-13.69,0-24.17-5.77A42.14,42.14,0,0,1,338,143a44.37,44.37,0,0,1-5.86-22.86,50.47,50.47,0,0,1,3.31-18.64,44.75,44.75,0,0,1,9.15-14.6,40.16,40.16,0,0,1,14-9.57A46.22,46.22,0,0,1,376.5,74a39,39,0,0,1,16,3.3,40.15,40.15,0,0,1,12.87,9,38.61,38.61,0,0,1,8.33,13.53,46.45,46.45,0,0,1,2.72,17.08l-.16,7.09H352.13a27.19,27.19,0,0,0,3.17,9.41A24,24,0,0,0,365.36,143a32.8,32.8,0,0,0,15.27,3.38,30.83,30.83,0,0,0,11.22-2,39.25,39.25,0,0,0,11-7.09l10.07,14a44.35,44.35,0,0,1-10.15,7,60.06,60.06,0,0,1-12,4.54,48.52,48.52,0,0,1-12.38,1.65Zm-20-54.45h38.18v-.83a18,18,0,0,0-3.3-9,19.77,19.77,0,0,0-7.18-6.1A20.87,20.87,0,0,0,376.5,92a27.21,27.21,0,0,0-13.61,3.13,20,20,0,0,0-8.33,9,26.43,26.43,0,0,0-2,6ZM815.8,162.9V40.8h20.29v71.26l36-36.12h27.06l-40.51,38,41,48.93H874.54l-29.72-36-8.73,8.2v27.8Zm-66.08-16.33a22.85,22.85,0,0,0,12.54-3.47,23.51,23.51,0,0,0,8.5-9.65,32,32,0,0,0,3-14.28,31,31,0,0,0-3-14,23.6,23.6,0,0,0-8.5-9.57,22.85,22.85,0,0,0-12.54-3.47,22.47,22.47,0,0,0-12.46,3.47,23.22,23.22,0,0,0-8.33,9.57,31.68,31.68,0,0,0-3,14,32.63,32.63,0,0,0,3,14.28,23.14,23.14,0,0,0,8.33,9.65,22.47,22.47,0,0,0,12.46,3.47Zm-5.61,18a33.88,33.88,0,0,1-19.47-5.94,42.87,42.87,0,0,1-14-16.17,50,50,0,0,1-5.28-23.27,50,50,0,0,1,5.28-23.26A40.59,40.59,0,0,1,725,79.9a37.3,37.3,0,0,1,20.46-5.77,36.25,36.25,0,0,1,12,1.9A30,30,0,0,1,767,81.39a31,31,0,0,1,6.11,6.76V75.94h20.46v87H773V150.72a32,32,0,0,1-7,6.65,41.28,41.28,0,0,1-10.06,5.2,34.76,34.76,0,0,1-11.8,2Zm-87.36,0q-13.71,0-24.18-5.77A42.11,42.11,0,0,1,616.24,143a44.27,44.27,0,0,1-5.86-22.86,50.68,50.68,0,0,1,3.3-18.64,44.61,44.61,0,0,1,9.16-14.6,40.12,40.12,0,0,1,14-9.57A46.29,46.29,0,0,1,654.76,74a39,39,0,0,1,16,3.3,40.15,40.15,0,0,1,12.87,9A38.46,38.46,0,0,1,692,99.79a46.45,46.45,0,0,1,2.73,17.08l-.17,7.09H630.39a27.19,27.19,0,0,0,3.17,9.41A24,24,0,0,0,643.63,143a32.73,32.73,0,0,0,15.26,3.38,30.83,30.83,0,0,0,11.22-2,39.25,39.25,0,0,0,11-7.09l10.07,14a44.14,44.14,0,0,1-10.15,7,59.83,59.83,0,0,1-12,4.54,48.5,48.5,0,0,1-12.37,1.65Zm-20-54.45h38.18v-.83a18,18,0,0,0-3.29-9,19.94,19.94,0,0,0-7.18-6.1A20.94,20.94,0,0,0,654.76,92a27.23,27.23,0,0,0-13.61,3.13,20,20,0,0,0-8.33,9,26.42,26.42,0,0,0-2,6Zm-81.19,36.3a22.53,22.53,0,0,0,12.37-3.46,23.53,23.53,0,0,0,8.5-9.57,30.94,30.94,0,0,0,3.05-14,31.12,31.12,0,0,0-3-13.94,24,24,0,0,0-33.57-9.57,23.68,23.68,0,0,0-8.5,9.48,32.91,32.91,0,0,0,0,28.06,24.34,24.34,0,0,0,8.5,9.57,22.72,22.72,0,0,0,12.62,3.46Zm-43.89,52.8V75.94h20l.19,11.23a25.39,25.39,0,0,1,2.29-2.56,36.81,36.81,0,0,1,25.24-10.15,37.22,37.22,0,0,1,20.55,5.77,40.53,40.53,0,0,1,14.19,15.84,50.09,50.09,0,0,1,5.2,23.27,50.17,50.17,0,0,1-5.2,23.18,41,41,0,0,1-14.19,16,36.31,36.31,0,0,1-20.22,5.86,37.08,37.08,0,0,1-14.6-3,37.81,37.81,0,0,1-11.88-7.76c-.39-.38-.7-.7-1.07-1.11V199.2Zm-49.58-34.65a52.59,52.59,0,0,1-20.71-3.88,37.2,37.2,0,0,1-14.93-11.13l13.2-11.39a29.65,29.65,0,0,0,11.05,8.09,34,34,0,0,0,12.88,2.47,17.71,17.71,0,0,0,5-.66,11.3,11.3,0,0,0,3.88-2,9.56,9.56,0,0,0,2.55-3,8.19,8.19,0,0,0,.91-3.88,7.52,7.52,0,0,0-3-6.27,24.28,24.28,0,0,0-5.2-2.47,76,76,0,0,0-9.16-2.64,72.43,72.43,0,0,1-14.85-5.37,30.52,30.52,0,0,1-9.24-6.84,21.13,21.13,0,0,1-4.2-7.1,25.4,25.4,0,0,1-1.41-8.58,21.65,21.65,0,0,1,2.56-10.48,26.2,26.2,0,0,1,7-8.17,32,32,0,0,1,10.4-5.28,42.14,42.14,0,0,1,12.38-1.81A49.33,49.33,0,0,1,474,75.78a48.52,48.52,0,0,1,11.55,4.7,35.48,35.48,0,0,1,9.16,7.35L483.5,100.2a42.62,42.62,0,0,0-6.85-5.28,40.8,40.8,0,0,0-7.5-3.71,20.44,20.44,0,0,0-7.1-1.4,25.09,25.09,0,0,0-5.61.57,11.88,11.88,0,0,0-4.12,1.73A8.05,8.05,0,0,0,449.76,95a8.54,8.54,0,0,0-.91,4,9.79,9.79,0,0,0,1.07,3.72,8.23,8.23,0,0,0,2.56,2.89,37.53,37.53,0,0,0,5.45,2.63,61.75,61.75,0,0,0,9.4,2.81,76.1,76.1,0,0,1,13.53,4.79,27.52,27.52,0,0,1,8.58,6.1,16.72,16.72,0,0,1,4.46,6.93,27.56,27.56,0,0,1,1.32,8.75,23.19,23.19,0,0,1-4.38,13.86A29.34,29.34,0,0,1,479,161.09a39.87,39.87,0,0,1-16.91,3.46ZM273.3,162.9v-87h20l.18,14.85a31.32,31.32,0,0,1,3.62-5.28,34.06,34.06,0,0,1,10.31-8.33,26.31,26.31,0,0,1,12.29-3.05,28.3,28.3,0,0,1,5.37.49,23.65,23.65,0,0,1,4.2,1.16l-5.44,22.27a19,19,0,0,0-4.46-1.65,21.68,21.68,0,0,0-5.28-.65,20,20,0,0,0-7.83,1.56,20.35,20.35,0,0,0-10.89,10.89,21.16,21.16,0,0,0-1.57,8.34V162.9Z"
            transform="translate(-60.38 -40.8)"
          />
          <path
            class="cls-2"
            d="M60.38,109v62.91A63,63,0,0,1,123.29,109h20.8A63,63,0,0,0,207,46.11H123.29A63,63,0,0,0,60.38,109Z"
            transform="translate(-60.38 -40.8)"
          />
          <path
            class="cls-3"
            d="M60.38,171.93v20.8a63,63,0,0,0,62.91-62.91V109A63,63,0,0,0,60.38,171.93Z"
            transform="translate(-60.38 -40.8)"
          />
          <path
            class="cls-4"
            d="M181.08,192.73a25.92,25.92,0,1,0-25.92-25.92A26,26,0,0,0,181.08,192.73Z"
            transform="translate(-60.38 -40.8)"
          />
          <path
            class="cls-5"
            d="M60.38,109v62.91A63,63,0,0,1,123.29,109V46.11A63,63,0,0,0,60.38,109Z"
            transform="translate(-60.38 -40.8)"
          />
        </svg>
      </button>
    </div>

    <v-spacer></v-spacer>

    <!-- navigation component for modules -->
    <moduleNavigation v-if="$vuetify.breakpoint.width > 1080" />
    <template
      v-slot:extension
      v-if="$vuetify.breakpoint.width <= 1080 && in_admin_dialog_view"
    >
      <moduleNavigation />
    </template>

    <v-spacer></v-spacer>

    <!-- navbar right side container -->
    <div class="rightSideItems">
      <template>
        <!-- special buttons in access: Restart button only in assess mode (testen) -->
        <v-toolbar-items v-if="$route.name == 'Assess'">
          <v-btn
            text
            title="Neu starten"
            @click="restart_or_delete('restart')"
            color="rgba(0, 0, 0, 0.54)"
          >
            <v-icon>mdi-repeat</v-icon>
          </v-btn>
        </v-toolbar-items>

        <!-- special buttons in analyse: Reload analysis data -->
        <v-toolbar-items v-if="$route.name == 'Analyse'">
          <v-btn
            text
            title="Update"
            icon
            @click="updateAnalysisData"
            color="rgba(0, 0, 0, 0.54)"
          >
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar-items>

        <template
          v-if="
            $route.name != 'Assess_live_exit' && $route.name != 'Dialog_exit'
          "
        >
          <!-- pricing and plans link -->
          <!-- <v-toolbar-items class="d-flex align-center mx-1">
            <v-chip label color="secondary">Admin</v-chip>
          </v-toolbar-items> -->

          <!-- share dialog with team -->
          <v-toolbar-items
            class="d-flex align-center"
            style="height: 30px"
            v-if="
              survey_data != null &&
              in_admin_dialog_view &&
              $vuetify.breakpoint.smAndUp
            "
          >
            <!-- active -->
            <v-btn
              elevation="0"
              @click="switch_activate_link(survey_data)"
              :disabled="survey_data.live_switch == 0"
              :loading="loading"
              :color="survey_data.active ? 'primary' : 'backdrop'"
              :dark="survey_data.active ? false : true"
            >
              <template v-if="survey_data.active">
                <v-icon left>mdi-eye</v-icon>
                <span>Live</span>
              </template>
              <template v-else>
                <v-icon left>mdi-eye-off</v-icon>
                <span>Inaktiv</span>
              </template>
            </v-btn>
          </v-toolbar-items>

          <!-- share dialog with team -->
          <v-toolbar-items
            class="d-flex align-center"
            style="height: 30px"
            v-if="
              survey_data != null &&
              in_admin_dialog_view &&
              $vuetify.breakpoint.smAndUp
            "
          >
            <v-menu
              offset-y
              :close-on-content-click="false"
              :close-on-click="true"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  small
                  color="secondary"
                  v-on="on"
                  v-if="in_admin_dialog_view"
                  >Team</v-btn
                ></template
              >
              <!-- sharing card -->
              <!--    SHARING POP UP-->
              <SharingDialog
                :survey_id="this.$route.params.survey_id"
                @close_dialog="close_dialog"
              ></SharingDialog>
            </v-menu>
          </v-toolbar-items>

          <!-- profile -->
          <v-toolbar-items style="max-height: 48px">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-list-item v-on="on">
                  <!-- on dashboard -->
                  <template
                    v-if="
                      ($route.name == 'Dashboard' || $route.name == 'Root') &&
                      $vuetify.breakpoint.smAndUp
                    "
                  >
                    <v-list-item-avatar class="my-0 mr-2">
                      <v-avatar color="#5ABAB2" size="35"
                        ><span style="font-size: 13px; color: white">{{
                          $store.state.auth.firstName != null &&
                          $store.state.auth.firstName != "null"
                            ? toInitials(
                                $store.state.auth.firstName +
                                  " " +
                                  $store.state.auth.lastName
                              )
                            : toInitials($store.state.auth.username)
                        }}</span></v-avatar
                      >
                    </v-list-item-avatar>

                    <v-list-item-title>
                      {{
                        $store.state.auth.firstName != null &&
                        $store.state.auth.firstName != "null"
                          ? $store.state.auth.firstName
                          : $store.state.auth.username
                      }}
                    </v-list-item-title>
                    <v-list-item-icon class="ml-0 mt-3">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-list-item-icon>
                  </template>
                  <!-- not on dashboard -->
                  <template v-else-if="$vuetify.breakpoint.smAndUp">
                    <v-avatar color="#5ABAB2" size="35"
                      ><span style="font-size: 13px; color: white">{{
                        $store.state.auth.firstName != null &&
                        $store.state.auth.firstName != "null"
                          ? toInitials(
                              $store.state.auth.firstName +
                                " " +
                                $store.state.auth.lastName
                            )
                          : toInitials($store.state.auth.username)
                      }}</span></v-avatar
                    >
                  </template>
                  <!-- on mobile -->
                  <template v-else>
                    <v-btn icon><v-icon>mdi-dots-horizontal</v-icon></v-btn>
                  </template>
                </v-list-item>
              </template>
              <v-list nav dense>
                <!-- profil changes -->
                <v-list-item two-line to="/account">
                  <v-list-item-avatar>
                    <v-avatar color="#5ABAB2" size="35"
                      ><span style="font-size: 13px; color: white">{{
                        $store.state.auth.firstName != null &&
                        $store.state.auth.firstName != "null"
                          ? toInitials(
                              $store.state.auth.firstName +
                                " " +
                                $store.state.auth.lastName
                            )
                          : toInitials($store.state.auth.username)
                      }}</span></v-avatar
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        $store.state.auth.firstName != null &&
                        $store.state.auth.firstName != "null"
                          ? $store.state.auth.firstName
                          : $store.state.auth.username
                      }}
                      {{
                        $store.state.auth.lastName != null &&
                        $store.state.auth.lastName != "null"
                          ? $store.state.auth.lastName
                          : ""
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Einstellungen </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <!-- help center -->
                <v-list-item
                  href="https://respeak.io/hilfe-center"
                  target="_blank"
                  title="hilfe-center"
                >
                  <v-list-item-icon>
                    <v-icon small>mdi-help-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Hilfe Center</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- data security -->
                <v-list-item
                  to="/datenschutz"
                  target="_blank"
                  title="Datenschutz"
                >
                  <v-list-item-icon>
                    <v-icon small>mdi-lock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Datenschutz</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- imprint -->
                <v-list-item to="/impressum" title="Impressum">
                  <v-list-item-icon>
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Impressum</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- AGB -->
                <v-list-item to="/agb" title="agb">
                  <v-list-item-icon>
                    <v-icon small>mdi-file-document-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>AGBs</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  to="/admin"
                  title="Admin"
                  v-if="check_if_local_host"
                >
                  <v-list-item-icon>
                    <v-icon small>mdi-cog</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Admin</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <!-- login -->
                <v-list-item v-if="!isAuth" to="/login" title="Login">
                  <v-list-item-icon>
                    <v-icon small color="success">mdi-login</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Login</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- logout -->
                <v-list-item v-else title="Logout" @click="onLogout">
                  <v-list-item-icon>
                    <v-icon small color="error">mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </template>
      </template>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import { instance as axiosAuth } from "@/api/axios-auth";
import { instance2 as axiosAuth_live } from "@/api/axios-auth_live";
import router from "@/router";
import SharingDialog from "./navbar_components/SharingDialog.vue";
import moduleNavigation from "./navbar_components/moduleNavigation.vue";
import { get_media_url } from "@/components/helper_functions.js";
import { reset_history_for_surveyIds } from "@/components/helper_functions";

export default {
  name: "NavBar",

  components: {
    SharingDialog,
    moduleNavigation,
  },

  data() {
    return {
      dialogNew: false,
      language: "de",
      dialogDel: false,
      intrance_switch: true,
      menuOpen: false,
      loading: false,
      show_sharing_dialog: false,
      navar_language_fragments: null,
      navbar_logo: "",
    };
  },

  async created() {
    // check if we are in assess or dialog to get language
    const unwatch = this.$watch(
      () => this.$route,
      (route) => {
        this.activeIndex = route.name;
        this.check_if_we_need_language();
        unwatch();
      }
    );
  },

  watch: {
    async $route(to, from) {
      // close menu on route change
      if (to != from) {
        this.menuOpen = false;
      }
    },

    client_config() {
      if (this.client_config?.logo_src != null) {
        this.navbar_logo = this.client_config.logo_src;
      } else {
        this.navbar_logo = get_media_url(this.$route.params.survey_id, "logo");
      }
      if (
        !this.navbar_logo.startsWith("https") &&
        !this.navbar_logo.startsWith("/img")
      ) {
        this.navbar_logo = require("@/assets/" + this.navbar_logo);
      }
    },
  },

  computed: {
    in_admin_dialog_view() {
      if (
        this.$route.name == "configurator" ||
        this.$route.name == "Intrance" ||
        this.$route.name == "Intrance_ai" ||
        this.$route.name == "Share" ||
        this.$route.name == "Assess" ||
        this.$route.name == "Analyse"
      ) {
        return true;
      } else {
        return false;
      }
    },

    //from auth store module
    ...mapGetters("auth", {
      isAuth: "isAuthenticated",
      userName: "getUserName",
    }),

    client_config() {
      return this.$store.state.client_config;
    },

    //current survey data
    survey_data() {
      return this.$store.state.survey_data;
    },

    check_if_local_host() {
      return window.location.hostname === "localhost";
    },

    getSurveyName() {
      let survey_id = this.$route.params.survey_id;

      if (this.survey_data != null) {
        if (this.survey_data.survey_id == survey_id) {
          return this.survey_data.survey_name;
        } else {
          return "Neuer Dialog";
        }
      } else {
        // multichat analyse
        if (this.$route.name == "AnalyseMultiChat") {
          return "Tatort-Game";
        }
        // loading
        return "loading...";
      }
    },
  },

  methods: {
    async check_if_we_need_language() {
      if (this.$route.name == "Dialog" || this.$route.name == "Assess") {
        let survey_id = this.$route.params.survey_id;

        //we need to get language
        await axiosAuth_live
          .post(`/api/get_survey_language`, {
            survey_id: survey_id,
          })
          .then((response) => {
            this.navar_language_fragments =
              response.data.nav_bar_information.navar_language_fragments;
            this.language = response.data.nav_bar_information.language;
          })
          .catch((error) => {
            this.$store.dispatch("error_alert", error);
          });
      }
    },

    open_sharing_screen() {
      this.show_sharing_dialog = true;
    },

    close_dialog() {
      this.show_sharing_dialog = false;
    },

    to_dashboard() {
      let route = this.$router.currentRoute;
      if (route.path == "/" || route.path == "/dashboard") {
        this.$router.go();
      } else {
        router.push("/dashboard");
      }
    },

    onLogout() {
      this.$store.dispatch("auth/logout");
    },

    changeMenuStatus(event) {
      // 0 = click, 1 = menu hide
      if (event == 0) {
        this.menuOpen = !this.menuOpen;
      } else {
        //1 only when menu open anyway
        this.menuOpen = false;
      }
    },

    triggerNavigate() {
      // goto intrance view with survey ID
      if (this.$route.name == "Assess") {
        this.$router.push({ name: "Intrance" });
      }
      // goto assess view with survey ID
      else {
        this.$router.push({ name: "Assess" });
      }
    },

    async restart_or_delete(value) {
      let survey_id = this.$route.params.survey_id;
      if (
        this.$router.currentRoute.name == "Assess_live" ||
        this.$route.name == "Dialog"
      ) {
        // #post to server to restart or delete current survey in Assess mode
        axiosAuth_live
          .post(
            `/api/restart_delete`,
            {
              survey_id: survey_id,
              action: value, //restart or delete
            },
            { disable_busy_message: true }
          )
          .then((response) => {
            if (response.status === 200) {
              if (value == "restart") {
                this.dialogNew = false;
                // reset history for dialog
                reset_history_for_surveyIds([this.$store.state.survey_id_int]);
                // reload current route
                this.$router.go(0);
              } else {
                // Show: delete confirmation? >> Need byebye path
                this.dialogDel = false;
                // remove information from local storage
                setTimeout(() => {
                  this.$store.dispatch("auth/clearAuthData_live");
                }, 0);
                //close current tab for now
                this.$router.push({
                  path: "/exit/deleted" + "_" + this.language,
                });
                // this.$router.push({name: "Assess_live_exit", params: 'deleted'});
              }
            }
          });
      } else {
        // #post to server to restart current survey in Assess mode
        await axiosAuth
          .post(`/api/restart_delete`, {
            survey_id: survey_id, //hard coded
            action: value, //restart or delete
          })
          .then((response) => {
            if (response.status === 200) {
              //reload current route
              this.$router.go(0);
            }
          });
      }
    },

    updateAnalysisData() {
      //trigger page reload
      this.$router.go();
    },

    toInitials(Inputstring) {
      if (Inputstring == null) {
        return "X";
      } else {
        return Inputstring.match(/(^\S\S?|\b\S)?/g)
          .join("")
          .match(/(^\S|\S$)?/g)
          .join("")
          .toUpperCase();
      }
    },

    //change live status
    async switch_activate_link(item) {
      this.loading = true;
      // switch active status of item and
      item.active = !item.active;
      // submit
      await axiosAuth
        .post(`/api/switch_activate_link`, {
          item: item,
        })
        .then((response) => {
          //if success change switch
          if (response.data.msg == "success") {
            // update survey data on $store
            this.$store.dispatch("updateSurveyData", { dialog: [item] });
            // if configurator reload route
            if (this.$route.name == "configurator") {
              this.$router.go(0);
            }
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$store.dispatch("error_alert", error);
        });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.divider {
  margin-left: 12px;
  margin-right: 12px;
}

.mobile .divider {
  margin-left: 4px;
  margin-right: 4px;
}

.navbar_style {
  z-index: 20 !important;
}

.survey_name {
  overflow: hidden;
  width: 200px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.navigation_left {
  font-size: 14px;
  color: grey;
  transition: 0.2s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile .navigation_left {
  display: flex;
  align-items: center;
}

.nav-item:hover {
  cursor: pointer;
  color: black;
  transition: 0.2s ease-in-out;
}

.short {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 125px;
  display: inline-block;
}

/* are you sure actions mobile style */

/* assess live button style for small mobile */
@media only screen and (max-width: 350px) {
  .assess_live_button_style {
    padding: 0 5px 0 0 !important;
    height: inherit !important;
    min-width: inherit !important;
  }
}

/* navbar top left navigation pagination */
.navigationPagination {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.navbar_style >>> .v-toolbar__extension {
  display: flex;
  justify-content: center;
}

/* right side container */
.rightSideItems {
  width: 300px;
  max-height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

/* logo */
.cls-1 {
  fill: #2a2f3b;
}

.cls-1,
.cls-2,
.cls-3,
.cls-4,
.cls-5 {
  fill-rule: evenodd;
}

.cls-2 {
  fill: #db3946;
}

.cls-3 {
  fill: #ffb400;
}

.cls-4 {
  fill: #23bdb2;
}

.cls-5 {
  fill: #f60;
}
.question_name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.survey_name2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
